






import BookComponentListFolder from './BookComponentListFolder.vue'
import { DemoFolder } from '../../classes/Main/DemoFolder'

export default {
  name: 'tree-demo-file-list',
  components: { BookComponentListFolder },
  props: {
    folder: {
      type: DemoFolder,
      required: true,
    },
  },
}
